import * as React from "react";

import { UitkLink } from "uitk-react-link";
import { UitkIcon } from "uitk-react-icons";
import { UitkCard, UitkCardContent, UitkCardSectionSeparatorType, UitkCardTextSegment } from "uitk-react-cards";

import { TrackedLink } from "src/components/utility/analytics/TrackedLink";

import { LinkJuiceCategorySectionProps } from "./typings";

const LinkJuiceCategorySection = (props: LinkJuiceCategorySectionProps) => {
  const { category, collapsed } = props;
  const { name, links } = category;
  if (!(name && links && links.length)) {
    return null;
  }

  const [isExpanded, setIsExpanded] = React.useState(!collapsed);

  const toggleExpansion = (): void => {
    setIsExpanded(!isExpanded);
  };

  return (
    <UitkCard className="all-t-margin-one">
      <UitkCardContent>
        <div
          data-testid="linkJuiceCategorySection"
          role="button"
          aria-expanded={isExpanded}
          className="header"
          onClick={toggleExpansion}
        >
          <UitkCardTextSegment
            className="all-y-padding-four uitk-flex uitk-flex-justify-content-space-between"
            separator={UitkCardSectionSeparatorType.BOTTOM}
          >
            <h3 className="uitk-type-heading-500">{name}</h3>
            <UitkIcon name={`expand_${isExpanded ? "less" : "more"}`} />
          </UitkCardTextSegment>
        </div>

        <UitkCardTextSegment
          aria-hidden={!isExpanded}
          className={`all-y-padding-two${isExpanded ? "" : " collapsedLink"}`}
        >
          {links.map(
            (link) =>
              link.text &&
              link.url && (
                <UitkLink key={link.url}>
                  <TrackedLink moduleName="link-juice" href={link.url} linkName={link.text}>
                    <span className="truncate">{link.text}</span>
                  </TrackedLink>
                </UitkLink>
              )
          )}
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
};

export default LinkJuiceCategorySection;
